<script setup lang="ts">
import {CustomNodeProps} from "@/core/interfaces/flowchart/flowchart";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/core/components/ui/tooltip";
import CustomNodeCriteria from "@/flowcharts/Components/CustomNodeCriteria.vue";

defineProps<{
    data: CustomNodeProps;
}>();
</script>

<template>
  <div class="text-xs mt-1" :class="data.highlighted ? 'text-slate-300' : 'text-slate-700'">
    <!-- Hovering the hint shows the same criteria as the "?"; a click still reaches the node and opens its action. -->
    <TooltipProvider v-if="data.description">
      <Tooltip :delay-duration="200">
        <TooltipTrigger as-child>
          <span class="cursor-help underline decoration-dotted underline-offset-2">{{ data.hint }}</span>
        </TooltipTrigger>
        <TooltipContent
          class="p-2 text-sm bg-white text-slate-950 border border-slate-200 shadow-md overflow-y-auto max-h-[min(70vh,var(--reka-tooltip-content-available-height))]"
          :collision-padding="16"
        >
          <CustomNodeCriteria :description="data.description" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
    <template v-else>
      {{ data.hint }}
    </template>
  </div>
</template>
